<template>
    <div class="structure-card card text-white bg-dark mb-3">
        <div class="card-header">{{ structure.name }}</div>
        <div class="card-body">
            <h6 class="card-subtitle mb-2 text-muted">{{ structure.structure_type.name }}</h6>
            <div class="card-text">
                <div class="info-item"><strong>Teléfono: </strong> {{ structure.phone }}</div>
                <div class="info-item"><strong>Extensión: </strong> {{ structure.extension }}</div>
                <div class="info-item"><strong>E-mail: </strong> {{ structure.email }}</div>
                <div class="info-item"><strong>Slug: </strong> {{ structure.slug }}</div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            structure: {
                type: Object,
                required: true
            }
        }
    }
</script>